import { put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { addDays, isAfter } from 'date-fns';
import { Action } from 'redux-actions';

import { ExchangeSegmentValue } from '../types';
import {
	SelectSegmentDatePayload,
	TOGGLE_ALL_SEGMENTS,
	TOGGLE_SEGMENT,
	SET_SEGMENT_DATE,
	setSegmentDate,
	clearSegmentsDate
} from './actions';
import { getIsAllSegmentsSelected, getSegments } from './selectors';
import { clearExchangeVariants } from '../exchangeVariants/actions';
import { getSelectedFlightsCount } from '../exchangeVariants/selectors';

function* resetSegmentsDate() {
	const selectedFlightsCount: number = yield select(getSelectedFlightsCount);

	if (selectedFlightsCount) {
		yield put(clearExchangeVariants());
	}

	yield put(clearSegmentsDate());
}

function* setCorrectSegmentDates() {
	const isAllSegments: boolean = yield select(getIsAllSegmentsSelected);

	if (!isAllSegments) {
		return;
	}

	const segments: ExchangeSegmentValue[] = yield select(getSegments);
	let correctDateSegmentAction: Action<SelectSegmentDatePayload> = null;

	let index = 0;

	while (!correctDateSegmentAction && index < segments.length - 1) {
		const segment = segments[index];
		const nextSegment = segments[index + 1];

		const segmentDate = segment.selectedDate ?? segment.date;
		const nextSegmentDate = nextSegment.selectedDate ?? nextSegment.date;

		if (isAfter(segmentDate, nextSegmentDate)) {
			correctDateSegmentAction = setSegmentDate({
				id: nextSegment.id,
				date: addDays(segmentDate, 1)
			});
		}

		index++;
	}

	if (correctDateSegmentAction) {
		yield delay(10);
		yield put(correctDateSegmentAction);
	}
}

export function* segmentsSagas() {
	yield takeLatest([TOGGLE_ALL_SEGMENTS, TOGGLE_SEGMENT], resetSegmentsDate);
	yield takeLatest(SET_SEGMENT_DATE, setCorrectSegmentDates);
}
